import React, {ReactElement} from 'react';

import Field from '../Field/Field';
import {Field as FieldType} from '../types';
import './RadioIconField.scss';

export interface ButtonInfo {
  image?: ReactElement;
  text: string;
  value: string;
  key?: string;
}

interface Props extends Omit<FieldType, 'onChange' | 'onBlur'> {
  onChange: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLButtonElement>) => void;
  options: ButtonInfo[];
  optionClassname?: string;
}

function RadioIconField({
  errorMessage = '',
  label,
  name,
  onChange,
  onBlur,
  value,
  options,
  isDisabled,
  optionClassname,
}: Props): ReactElement {
  return (
    <Field label={label} name={name} errorMessage={errorMessage} isDisabled={isDisabled}>
      <div className="radioIconField">
        {options.map(({text, image, value: buttonValue, key}) => (
          <button
            name={name}
            id={`radioIconField__button--${buttonValue}`}
            data-testid={`radioIconField__button--${buttonValue}`}
            key={key || text}
            type="button"
            onClick={onChange}
            onBlur={onBlur}
            className={`radioIconField__button ${value === buttonValue ? 'radioIconField__button--selected' : ''} ${
              optionClassname || ''
            }`.trim()}
            aria-pressed={value === buttonValue}
            value={buttonValue}
            disabled={isDisabled}
          >
            {image && image}
            {text}
          </button>
        ))}
      </div>
    </Field>
  );
}

export default RadioIconField;
